import FJCanvasPool from '../FJCanvasPool';
import FJExportLayer from './FJExportLayer';
import FJRenderState from './FJRenderState';
import FJDomRenderManager from './FJDomRenderManager';
class FJDomLayer extends FJExportLayer {
    constructor(props) {
        super(props);
        this._time = props.time;
        this._element = props.element;
        this._exportSize = props.exportSize;
        const id = this._element.getId();
        let domRender = FJDomRenderManager.getDomRender(id);
        if (!domRender) {
            this._element.prepareToExport(this._exportSize);
            domRender = FJDomRenderManager.startRenderElement(this._element, this._time, {
                exportSize: this._exportSize,
            });
        }

        const frameIndex = domRender.bindFrameIndex();
        this._domRender = { domRender, frameIndex };
    }
    start() {
        this._status = FJRenderState.RENDERING;
        const { domRender, frameIndex } = this._domRender;
        if (!domRender.framePreparedAtIndex(frameIndex)) {
            domRender.watchFrameAtIndex(frameIndex, err => {
                if (err) {
                    this._error(err);
                } else {
                    this._checkPrepared();
                }
            });
        }
        this._checkPrepared();
    }
    /**
     * @desc 检查是否准备好渲染
     * @private
     */
    _checkPrepared() {
        if (this.prepared() && this._status === FJRenderState.RENDERING) {
            this._done();
        }
    }

    /**
     * @desc 当前层是否准备好
     * @return {boolean}
     */
    prepared() {
        const { domRender, frameIndex } = this._domRender;
        if (domRender.errMsg) {
            this._error(domRender.errMsg);
            return false;
        }

        return domRender.framePreparedAtIndex(frameIndex);
    }
    /**
     * @desc 绘制到画布
     * @param canvas
     */
    drawToCanvas(canvas) {
        try {
            const { domRender, frameIndex } = this._domRender;
            const frameData = domRender.getFrameAtIndex(frameIndex);
            const { frame, canRelease } = frameData;
            // 文字外扩像素大小  不是尺寸，而是像素
            const expandSize = domRender.expandSize;
            const domSize = domRender.domSize;
            this._element.drawContentFrameAtTimeToCanvas(frame, this._time, canvas, domSize, expandSize);
            if (canRelease) {
                FJCanvasPool.releaseCanvas(frame);
            }
        } catch (e) {
            this._errMsg = e.message;
        }
    }
}
export default FJDomLayer;
